@if (photos().length > 0) {
    <div class="image-list">
        @for (photo of photos(); track photo.uid) {
            <div class="preview-container">
                <div class="thumbnail-wrapper" (click)="onPreview(photo)">
                    <img
                        [src]="photo.thumbUrl"
                        [alt]="photo.name"
                        class="thumbnail" />
                </div>
                <div class="file-info">
                    <pf-text type="description">{{ photo.name }}</pf-text>
                    <div class="file-actions">
                        <pf-button
                            buttonType="icon"
                            pfIcon="viewDetails"
                            buttonSize="small"
                            (click)="onPreview(photo)"></pf-button>
                        <pf-button
                            buttonType="icon"
                            pfIcon="circleX"
                            buttonSize="small"
                            [pfDanger]="true"
                            (click)="onDelete(photo)"></pf-button>
                    </div>
                </div>
            </div>
        }
    </div>
}

@if (canAddMore()) {
    <cpw-photo-capture
        [disabled]="disabled()"
        [captureLabel]="captureLabel()"
        [uploadLabel]="uploadLabel()"
        (photoCaptured)="onPhotoCaptured($event)">
    </cpw-photo-capture>
}

@if (previewFile(); as preview) {
    <div class="preview-overlay" (click)="onClosePreview()">
        <div class="preview-overlay-content" (click)="$event.stopPropagation()">
            <img
                [src]="preview.thumbUrl"
                alt="Photo preview"
                class="preview-image" />
            <pf-button
                buttonType="icon"
                pfIcon="close"
                class="preview-close"
                (click)="onClosePreview()"></pf-button>
        </div>
    </div>
}
